import React from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { addPackage } from "store/actions";

import { useNavigate } from "react-router-dom";
import { getId } from "helpers/functions";
import SlidersArray from "./SliderArray";
import MultiLangWrapper from "components/shared/MultiLangsWrapper";
import { FormattedMessage } from "react-intl";

const AddPackage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  const onSubmit = (data) => {
    dispatch(addPackage({ data, navigate }));
  };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id="addPackage" />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={8} md={12}>
                <Row>
                  <Col xs={12}>
                    <MultiLangWrapper
                      label={
                        <label>
                          <FormattedMessage id={"title"} />
                        </label>
                      }
                      errors={errors?.title}
                      customClass="form-group selectHolder col-12"
                    >
                      {({ lang, classes, key }) => (
                        <input
                          key={key}
                          type="text"
                          className={`form-control form-outline ${classes}`}
                          {...register(`title.${lang}`, { required: true })}
                        />
                      )}
                    </MultiLangWrapper>
                  </Col>
                  <Col xs={8}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="price" />
                      </h5>
                      <div>
                        <input
                          type="number"
                          className="form-control form-outline"
                          {...register("price", { required: true })}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={4}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="isRecommended" />
                      </h5>
                      <div>
                        <input
                          type="checkbox"
                          className="form-control form-outline"
                          {...register("isRecommended")}
                        />
                      </div>
                    </div>
                  </Col>
                  <SlidersArray
                    register={register}
                    control={control}
                    errors={errors}
                  />
                </Row>
                <Row>
                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        اضافة
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPackage;
